import { KoobPlaceAutocomplete } from '@koob/maps';
import { KoobInputLabel, KoobInputText, koobTagVariants } from '@koob/ui';
import { useState } from 'react';
import { useField } from 'formik';

const toPlace = (place) => ({
  name: place.name,
  address: place.formatted_address,
  city: place.address_components?.find((c) => c.types.includes('locality'))
    ?.long_name,
  country: place.address_components?.find((c) => c.types.includes('country'))
    ?.long_name,
  lat: place.geometry.location.lat(),
  lon: place.geometry.location.lng(),
  isCity: place.types.includes('locality'),
});

// A list of Google places: a search box, then each pick as a removable tag.
export default function MapsPlaceSearchField({
  name,
  label,
  placeholder,
  disabled,
}) {
  const [{ value = [] }, , { setValue }] = useField(name);
  const [query, setQuery] = useState('');

  return (
    <div>
      {label && <KoobInputLabel htmlFor={name} label={label} />}

      {!disabled && (
        <KoobPlaceAutocomplete
          onPlaceSelect={(place) => {
            if (place?.geometry) {
              setValue([...value, toPlace(place)]);
              setQuery('');
            }
          }}
        >
          <KoobInputText
            id={name}
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={placeholder}
            iconLeft={<i className="fa-regular fa-location-dot" />}
          />
        </KoobPlaceAutocomplete>
      )}

      {value.length > 0 && (
        <div className="mt-2 flex flex-wrap gap-1">
          {value.map((place, index) => (
            <span key={`${place.name}-${index}`} className={koobTagVariants()}>
              <span className="min-w-0 truncate">{place.name}</span>
              {!disabled && (
                <button
                  type="button"
                  aria-label={`Remove ${place.name}`}
                  className="-mr-0.5 flex h-4 w-4 shrink-0 cursor-pointer items-center justify-center rounded border-none bg-transparent p-0 text-gray-400 transition-colors hover:bg-gray-200 hover:text-gray-700"
                  onClick={() => setValue(value.filter((_, i) => i !== index))}
                >
                  <i className="fa-light fa-xmark" aria-hidden />
                </button>
              )}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
